import {createCrudActions} from './objectApiDucks';

const MODEL = 'constructedResponseAnswer';
const URL = 'constructedresponseanswer';

const actions = createCrudActions(MODEL, URL);

export const fetchConstructedResponseAnswer = actions.fetchRecord;
export const fetchConstructedResponseAnswers = actions.fetchCollection;
